(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  const root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let closeTimer = 0;

  const open = () => {
    window.clearTimeout(closeTimer);
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    if (motionQuery.matches) {
      root.classList.add('is-open');
      return;
    }
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        root.classList.add('is-open');
      });
    });
  };

  const finishClose = () => {
    root.hidden = true;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const close = () => {
    if (root.hidden) return;
    root.classList.remove('is-open');
    if (motionQuery.matches) {
      finishClose();
      return;
    }
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(finishClose, 360);
  };

  const setCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      const next = String(count);
      const changed = node.textContent !== next;
      node.textContent = next;
      node.hidden = count < 1;
      if (!changed || motionQuery.matches) return;
      node.classList.remove('is-pop');
      node.offsetWidth;
      node.classList.add('is-pop');
      const cart = node.closest('.site-header__cart');
      if (!cart) return;
      cart.classList.remove('is-bump');
      cart.offsetWidth;
      cart.classList.add('is-bump');
    });
  };

  const refresh = async () => {
    const response = await fetch('/?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    const sections = await response.json();
    const html = sections['cart-drawer'];
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-cart-drawer-panel]');
    const current = root.querySelector('[data-cart-drawer-panel]');
    if (next && current) current.replaceWith(next);
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((result) => result.json());
    setCount(cart.item_count);
  };

  const changeLine = async (id, quantity) => {
    await fetch(root.dataset.changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    });
    await refresh();
    open();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
    const submitter = event.submitter;
    if (submitter && submitter.name && submitter.name !== 'add') return;
    event.preventDefault();
    const response = await fetch(root.dataset.addUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    });
    if (!response.ok) return;
    await refresh();
    open();
  });

  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-cart-drawer-close]');
    if (closer) close();
    const line = event.target.closest('[data-cart-line]');
    if (line) {
      const quantity = Number(line.dataset.cartQty);
      const item = line.closest('.cart-drawer__item');
      if (item && quantity === 0 && !motionQuery.matches) {
        item.classList.add('is-leaving');
        window.setTimeout(() => changeLine(line.dataset.cartLine, quantity), 180);
      } else {
        changeLine(line.dataset.cartLine, quantity);
      }
    }
    const cartLink = event.target.closest('[data-open-cart]');
    if (cartLink) {
      event.preventDefault();
      refresh().then(open);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initSiteHeader(header) {
    if (header.dataset.menuReady === 'true') return;
    header.dataset.menuReady = 'true';

    const button = header.querySelector('[data-menu-toggle]');
    const menu = header.querySelector('[data-mobile-menu]');
    if (!button || !menu) return;

    let menuTimer = 0;

    function setOpen(isOpen) {
      button.setAttribute('aria-expanded', String(isOpen));
      button.setAttribute('aria-label', isOpen ? button.dataset.labelClose : button.dataset.labelOpen);
      window.clearTimeout(menuTimer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        menu.classList.toggle('is-open', isOpen);
        menu.hidden = !isOpen;
        if (isOpen) {
          const reducedItem = menu.querySelector('a, summary');
          if (reducedItem) reducedItem.focus();
        }
        return;
      }
      menu.classList.add('is-animating');

      if (isOpen) {
        menu.hidden = false;
        window.requestAnimationFrame(function () {
          menu.classList.add('is-open');
        });
        const firstItem = menu.querySelector('a, summary');
        if (firstItem) firstItem.focus();
        return;
      }

      menu.classList.remove('is-open');
      menuTimer = window.setTimeout(function () {
        if (button.getAttribute('aria-expanded') !== 'true') menu.hidden = true;
      }, 240);
    }

    button.addEventListener('click', function () {
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    });

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (button.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      button.focus();
    });
  }

  document.querySelectorAll('[data-site-header]').forEach(initSiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snack-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-spotlight]').forEach((root) => {
    const track = root.querySelector('[data-spotlight-track]');
    const slides = root.querySelectorAll('[data-spotlight-slide]');
    const dots = root.querySelectorAll('[data-spotlight-dot]');
    if (!track || slides.length < 1) return;

    let index = 0;
    let timer = 0;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (index * -100) + '%)';
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const stop = () => window.clearInterval(timer);

    const start = () => {
      stop();
      if (reduced || slides.length < 2) return;
      timer = window.setInterval(() => show(index + 1), 8000);
    };

    root.querySelector('[data-spotlight-prev]').addEventListener('click', () => {
      stop();
      show(index - 1);
    });
    root.querySelector('[data-spotlight-next]').addEventListener('click', () => {
      stop();
      show(index + 1);
    });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        stop();
        show(dotIndex);
      });
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        stop();
        show(index - 1);
      }
      if (event.key === 'ArrowRight') {
        stop();
        show(index + 1);
      }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('touchstart', stop, { passive: true });

    show(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
